export default function Thumbnail(props) {
  return (
    <div className="project-card">
      <img className="thumbnail" src={props.thumbnail} alt="dataviz" />

      <h2>{props.title}</h2>
      <h4>{props.description}</h4>
      <div className="tags">
        <div className="tag">{props.tag1}</div>
        <div className="tag">{props.tag2}</div>
      </div>
    </div>
  );
}
